export function base64ToFile(base64String: string, fileName: string): File {
  // Convert base64 to blob
  const formattedBase64String = formatBase64(base64String);
  const byteString = atob(formattedBase64String.split(",")[1]);
  const mimeString = formattedBase64String
    .split(",")[0]
    .split(":")[1]
    .split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([ab], { type: mimeString });

  // Convert blob to file
  const file = new File([blob], fileName, { type: mimeString });
  return file;
}

function formatBase64(base64: string) {
  const hasMimeType = base64.includes("data:image");
  if (hasMimeType) {
    return base64;
  } else {
    return `data:image/jpeg;base64,${base64}`;
  }
}
